import React from 'react';
import UpgradeModalManager from '@/v3-dashboard/components/UpgradeModals/UpgradeModalManager';
import DModalDemoUpgrade from '@/components/DModalDemoUpgrade';
import useModalStore from '@/stores/modal/modalStore';
import WelcomeBackCampaignModal from '@/components/WelcomeBackCampaignModal';
import useAnnouncementModal from '@/hooks/useAnnouncementModal';
import useWelcomeBackModal from '@/hooks/useWelcomeBackModal';
import useNewUpdatesModal from '@/hooks/useNewUpdatesModal';
import ClaudeModelsModalContainer from '@/components/ClaudeModelsModalContainer';
import NewBubbleModalContainer from '@/components/NewBubbleModalContainer';
import NewUpdatesModalContainer from '@/components/NewUpdatesModalContainer';
import AnnouncementModalContainer from '@/components/AnnouncementModalContainer';

/**
 * GlobalModals component
 *
 * This component manages application-wide modals that can be triggered from anywhere in the app.
 * It should be included in the main layout component(s) of the application.
 */
const GlobalModals = ({ removeBackdrop = false }) => {
  // Run first so we see just_logged_in before other modals clear it; controls 24h-delayed announcement modal
  useAnnouncementModal();
  const { showDemoUpgrade, closeDemoUpgradeModal } = useModalStore();

  // Initialize the welcome back modal hook
  useWelcomeBackModal();

  // Initialize the new updates modal hook
  useNewUpdatesModal();

  return (
    <>
      {/* Plans / upgrade modal (path-specific or full plans) */}
      <UpgradeModalManager removeBackdrop={removeBackdrop} />

      {/* Welcome Back Campaign Modal */}
      <WelcomeBackCampaignModal />

      {/* Claude Models Modal */}
      <ClaudeModelsModalContainer />

      {/* New Bubble Modal */}
      {/* <NewBubbleModalContainer /> */}

      {/* New Updates Modal */}
      {/* <NewUpdatesModalContainer /> */}

      {/* Announcement Modal */}
      <AnnouncementModalContainer />

      {/* Demo upgrade modal */}
      <DModalDemoUpgrade
        isOpen={showDemoUpgrade}
        onClose={closeDemoUpgradeModal}
      />

      {/* Additional global modals can be added here */}
    </>
  );
};

export default GlobalModals;